import { z } from 'zod';

/** Downloads are private snapshots, never public subscription feeds. */
export const calendarWorkspace = z.enum(['professional', 'office']);
export type CalendarWorkspace = z.infer<typeof calendarWorkspace>;

const calendarDate = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Use a calendar date in YYYY-MM-DD format')
  .refine((value) => {
    const parsed = new Date(`${value}T00:00:00Z`);
    return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
  }, 'Use a valid calendar date');

export const calendarBookingQuery = z.object({ workspace: calendarWorkspace }).strict();
export const calendarRangeQuery = z
  .object({ workspace: calendarWorkspace, from: calendarDate, to: calendarDate })
  .strict()
  .superRefine((value, context) => {
    const days = (Date.parse(value.to) - Date.parse(value.from)) / 86_400_000;
    if (!Number.isFinite(days) || days < 0 || days > 92) {
      context.addIssue({
        code: 'custom',
        path: ['to'],
        message: 'Choose an ordered date range of at most 93 days',
      });
    }
  });
export type CalendarRangeQuery = z.infer<typeof calendarRangeQuery>;
export interface CalendarDownload {
  content: string;
  filename: string;
  eventCount: number;
}
